import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCourseId: null,
  activeModuleId: null,
  activeCourseModulesList: [],
  activeModuleActivities: [],
  activeActivityId: null
};

const syncStateSlice = createSlice({
  name: 'freeCourseStatic',
  initialState,
  reducers: {
    setActiveCourseId: (state, action) => {
      state.activeCourseId = action.payload;
    },
    setActiveModuleId: (state, action) => {
      state.activeModuleId = action.payload;
    },
    setActiveCourseModulesList: (state, action) => {
      state.activeCourseModulesList = action.payload;
    },
    setActiveModuleActivities: (state, action) => {
      state.activeModuleActivities = action.payload;
    },
    setActiveActivityId: (state, action) => {
      state.activeActivityId = action.payload;
    },
    resetState: (state) => {
      return initialState;
    }
  }
});

export const {
  setActiveCourseId,
  setActiveModuleId,
  setActiveCourseModulesList,
  setActiveModuleActivities,
  setActiveActivityId,
  resetState
} = syncStateSlice.actions;

export default syncStateSlice.reducer;
